import React from 'react';
import { Label } from 'semantic-ui-react';
import { formatCurrency } from '../services';

/**
 * bCare cell with optional HYN billable care display
 * Shows clickable bCare amount with asterisk notation for HYN contracts
 */
const BCareCell = ({
    bCare,
    providerTotalHygienistBillableCare,
    abbr,
    onClickHandler,
    showAsterisk = false
}) => {
    return (
        <td>
            <Label
                className="cursorPointer primaryColor d-flex"
                onClick={onClickHandler}
            >
                {formatCurrency(bCare || 0)}
            </Label>
            {
                showAsterisk && providerTotalHygienistBillableCare > 0 &&
                <>
                    <br />
                    <Label content={`*${formatCurrency(providerTotalHygienistBillableCare)}*`} basic={true} className="mt-1" />
                </>
            }
        </td>
    );
};

export default BCareCell;
